export default {
  root: {
    "@media (min-width: 960px)": {
      minWidth: 100,
    },
  },
};
